import { Link } from "react-router-dom";
import { Mail, Instagram, Youtube, Phone } from "lucide-react";

export default function Footer() {
  return (
    <footer className="border-t border-white/10 bg-[#050505] mt-24">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <img
              src="/dglogo.png"
              alt="Dark Growers Genetics"
              className="h-16 w-auto object-contain"
            />
            <a
              href="mailto:darkgrowers@gmail.com"
              data-testid="footer-email"
              className="inline-flex items-center gap-2 text-emerald-400 hover:text-emerald-300 text-sm mt-6"
            >
              <Mail size={15} /> darkgrowers@gmail.com
            </a>
            <a
              href="tel:844-305-1247"
              data-testid="footer-phone"
              className="flex items-center gap-2 text-slate-300 hover:text-emerald-400 text-sm mt-3"
            >
              <Phone size={15} className="text-emerald-500" /> Customer Support available 24/7: 844-305-1247
            </a>

            <div className="flex items-center gap-3 mt-6" data-testid="footer-socials">
              <a
                href="https://instagram.com/darkgrowers"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Dark Growers on Instagram"
                data-testid="footer-instagram"
                className="flex items-center justify-center w-10 h-10 border border-white/15 text-slate-300 hover:border-emerald-500 hover:text-emerald-400 transition-colors"
              >
                <Instagram size={18} />
              </a>
              <a
                href="https://youtube.com/darkgrowers"
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Dark Growers on YouTube"
                data-testid="footer-youtube"
                className="flex items-center justify-center w-10 h-10 border border-white/15 text-slate-300 hover:border-emerald-500 hover:text-emerald-400 transition-colors"
              >
                <Youtube size={18} />
              </a>
            </div>

            <div className="mt-8 border-t border-white/10 pt-6 max-w-md" data-testid="footer-notice">
              <p className="label-caps text-slate-400 text-[0.62rem] mb-3">
                Notice to Regulatory &amp; Law Enforcement Authorities
              </p>
              <div className="space-y-3 text-xs text-slate-500 leading-relaxed">
                <p>
                  The material in this shipment contains 100% legal hemp in compliance with state and
                  federal laws. It should not be detained.
                </p>
                <p>All products are below 0.3% Delta 9 THC.</p>
                <p>
                  Please visit our website darkgrowers.com or contact us for a compliant Certificate of
                  Analysis on all products enclosed in this package. Thank you.
                </p>
                <p>
                  If you need to reach us, please email{" "}
                  <a href="mailto:darkgrowers@gmail.com" className="text-emerald-400/80 hover:text-emerald-300">
                    darkgrowers@gmail.com
                  </a>
                  .
                </p>
              </div>
            </div>
          </div>
          <div>
            <p className="label-caps text-slate-500 mb-5">Shop</p>
            <ul className="space-y-3 text-sm text-slate-400">
              <li><Link to="/shop/clones" className="hover:text-white">Clones</Link></li>
              <li><Link to="/shop/seeds" className="hover:text-white">Seeds</Link></li>
              <li><Link to="/shop" className="hover:text-white">All Genetics</Link></li>
            </ul>
          </div>
          <div>
            <p className="label-caps text-slate-500 mb-5">Company</p>
            <ul className="space-y-3 text-sm text-slate-400">
              <li><Link to="/about" className="hover:text-white">About Us</Link></li>
              <li><Link to="/account" className="hover:text-white">My Account</Link></li>
            </ul>

            <p className="label-caps text-slate-500 mb-5 mt-10">Education</p>
            <a
              href="/docs/2018-farm-bill-hemp-primer.pdf"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-hemp-pdf"
              className="text-sm text-slate-400 hover:text-white"
            >
              Hemp Legality: The 2018 Farm Bill (PDF)
            </a>
            <p className="text-xs text-slate-600 leading-relaxed mt-2">
              Federal hemp definitions were updated effective November 2026. This document reflects
              the 2018 law. For educational purposes only — not legal advice.
            </p>
          </div>
        </div>
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between gap-4">
          <p className="text-xs text-slate-500">© DARK GROWERS INC. 2026 — All rights reserved.</p>
          <p className="text-xs text-slate-600 max-w-md md:text-right">
            All products contain less than 0.3% Delta-9 THC and comply with state and federal law.
            Must be 21+.
          </p>
        </div>
      </div>
    </footer>
  );
}
